import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./client.api";
import axios from "axios";
import { tenantService } from "@/services/tenant/tentant.service";
import { Resource } from "@exibra/shared";
import isNil from "lodash.isnil";

export interface Tenant {
    id: number;
    name: string;
    createdAt: string;
}

export interface CreateTenantDto {
    name: string;
    billing: {
        address: string;
        city: string;
        country: string;
        postalCode: string;
        email: string;
    };
}

export const tenantApiQueryKeys = {
    availableTenants: "available-tenants",
    tenant: (id: number) => `${Resource.Tenant}/${id}`,
};

export const tenantApi = {
    /**
     * Create a new tenant
     */
    createTenant: async (tenantData: CreateTenantDto): Promise<Tenant> => {
        try {
            console.log("Creating tenant:", tenantData);
            const response = await apiClient.post("/tenants", tenantData);
            console.log("Create tenant response:", response.data);
            return response.data.tenant;
        } catch (error: unknown) {
            console.error("Error creating tenant:", error);
            if (axios.isAxiosError(error)) {
                console.error("Response data:", error.response?.data);
                console.error("Response status:", error.response?.status);
            }
            throw error;
        }
    },
};

/**
 * Hook to fetch the tenants for the current user
 */
export const useTenants = () => {
    return useQuery({
        queryKey: [tenantApiQueryKeys.availableTenants],
        queryFn: () => tenantService.getAvailableTenants(),
    });
};

export const useTenant = (id?: number) => {
    return useQuery({
        queryKey: [tenantApiQueryKeys.tenant(id!)],
        queryFn: () => tenantService.getTenant(id!),
        enabled: !isNil(id),
        throwOnError: false,
    });
};
